module.exports = __webpack_public_path__ + "static/media/iphone-img-test.7f608e38.svg";